/*
 * @Author: randy
 * @Date: 2020-07-31 14:23:46
 * @LastEditTime: 2020-11-09 10:43:09
 * @Description: 超级管理员路由
 */
import EyeUserLayout from "@/layout/EyeUserLayout";
import AdminBasicLayout from "@/layout/AdminBasicLayout";
// 儿科 眼科 产科 管理员登录
import CommonLogin from "@/views/login/admin_login";
import CommonUpdatePassword from "@/views/login/update_password";
import Redirect from "@/views/redirect/index";
// 强制修改密码
import UpdatePwd from "@/views/login/update_pwd";

let UserLayout = null;
let Login = null;
let UpdatePassword = null;

if (process.env.VUE_APP_PROJECT_NAME === "eye") {
  UserLayout = EyeUserLayout;
  Login = CommonLogin;
  UpdatePassword = CommonUpdatePassword;
}

const routes = [
  {
    path: "/user",
    name: "UserLayout",
    component: UserLayout,
    children: [
      {
        path: "/user/login",
        name: "Login",
        component: Login
        // component: () =>
        //   import(/* webpackChunkName: "adminlogin" */ "../views/login/admin_login.vue")
      },
      {
        path: "/user/updatepassword",
        name: "UpdatePassword",
        component: UpdatePassword
      },
      {
        path: "/user/updatepwd",
        name: "UpdatePwd",
        component: UpdatePwd
      }
    ]
  },
  // 用来做刷新
  {
    path: "/redirect",
    name: "RedirectAdminBasicLayout",
    component: AdminBasicLayout,
    children: [
      {
        path: "/redirect/:path*",
        name: "Redirect",
        component: Redirect
      }
    ]
  }
];

let devRoutes = [];

// dev 调试路由
if (process.env.NODE_ENV === "development") {
  devRoutes = devRoutes.concat([
    {
      id: 9900,
      name: "Test",
      path: "/test",
      component: "layout/RouterViewLayout.vue",
      parentId: 0,
      title: "本地调试",
      icon: "bug",
      menuShow: true,
      redirect: "/test/osstest"
    },
    {
      id: 9901,
      name: "OssTest",
      path: "/test/osstest",
      component: "views/test/oss_test.vue",
      parentId: 9900,
      title: "上传文件调试",
      menuShow: true,
      keepAlive: false
    },
    {
      id: 9902,
      name: "MessageTest",
      path: "/test/messagetest",
      component: "views/test/message_test.vue",
      parentId: 9900,
      title: "消息调试",
      menuShow: true,
      keepAlive: false
    },
    {
      id: 9903,
      name: "FooterToolBarTest",
      path: "/test/footertoolbartest",
      component: "views/test/footer_tool_bar_test.vue",
      parentId: 9900,
      title: "FooterToolBar",
      menuShow: true
    },
    {
      id: 9904,
      name: "HistoryToolBarTest",
      path: "/test/historytoolbartest",
      component: "views/test/history_tool_bar_test.vue",
      parentId: 9900,
      title: "HistoryToolBar",
      menuShow: true
    },
    {
      id: 9905,
      name: "VideoTest",
      path: "/test/videotest",
      component: "views/test/video_test.vue",
      parentId: 9900,
      title: "VideoTest",
      menuShow: true
    },
    {
      id: 9906,
      name: "KeepAliveTest",
      path: "/test/keepalivetest",
      component: "views/test/keep_alive_test.vue",
      parentId: 9900,
      title: "KeepAliveTest",
      keepAlive: false,
      menuShow: true
    }
  ]);
}

export { devRoutes };

export default routes;
